import { FilterOptions, RateSheet } from "./types";

export const filterSheets = (
  sheets: RateSheet[],
  filters: FilterOptions | null
): RateSheet[] => {
  if (!filters) {
    return sheets;
  }

  const { searchText, assignable, showArchived } = filters;
  const lcText = searchText?.toLowerCase() || null;

  return sheets
    .filter((x) => showArchived == null || x.archived === showArchived)
    .filter(
      (x) =>
        assignable == "All" ||
        (assignable == "Assignable" && x.allowAssignment) ||
        (assignable == "Unassignable" && !x.allowAssignment)
    )
    .filter((x) => !lcText || x.name.toLowerCase().includes(lcText));
};
